import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const CrowdclassFallback = () => {
  return (
    <div className="center-absolutely" >
      <CircularProgress color="warning" />
    </div>
  );
};

export default CrowdclassFallback;